export default {
  props: {
    promotionData: {
      type: [Array, Object, Boolean],
      default: null
    },
    backgroundImage: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      content: []
    }
  },
  computed: {
    styleClass () {
      return this.promotionData
        ? `promotion--${this.promotionData.style}`
        : null
    },
    promotionContent () {
      if (this.promotionData.content === 'DEFAULT') {
        return this.content
      }
      return this.promotionData.content
    }
  },
  methods: {
    shouldShow (link) {
      return (
        this.$router.resolve({ path: link }).href !==
        this.$router.resolve({ path: this.$route.fullPath }).href
      )
    },
    onClick () {
      if (this.promotionData.link) {
        this.$router.push(this.promotionData.link).catch(() => {})
      }
    }
  }
}
